import { render, staticRenderFns } from "./LedgerSection.vue?vue&type=template&id=66c194c9&scoped=true"
import script from "./LedgerSection.vue?vue&type=script&lang=ts"
export * from "./LedgerSection.vue?vue&type=script&lang=ts"
import style0 from "./LedgerSection.vue?vue&type=style&index=0&id=66c194c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c194c9",
  null
  
)

export default component.exports